// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-items-flex-end{align-items:flex-end}`, "",{"version":3,"sources":["webpack://./packages/builder-setup/job-admin/components/job-spec-template-details/jst-paragraph-form/jst-paragraph-form.component.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA","sourcesContent":[".align-items-flex-end{\n  align-items: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
